import axios from 'axios';
import { firebaseAuth } from './firebase';

const API_BASE_URL = import.meta.env['VITE_API_URL'] ?? '/api';

export const api = axios.create({
  baseURL: API_BASE_URL,
  // Note: Do NOT set Content-Type: application/json as a default header.
  // Axios sets it automatically when a body is provided.
  // Setting it explicitly causes POST requests with no body to send the header
  // without a body, which Fastify's strict JSON parser rejects with HTTP 400.
});

// Attach Firebase ID token to every request
api.interceptors.request.use(async (config) => {
  const user = firebaseAuth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired — Firebase SDK auto-refreshes, so just reject
      console.error('Authentication failed. Please log in again.');
    }
    return Promise.reject(error);
  }
);

export type ApiSuccess<T> = { data: T; error: null };
export type ApiError = { data: null; error: { code: string; message: string } };
export type ApiResponse<T> = ApiSuccess<T> | ApiError;
